// src/components/molecules/ToolbarPrimaryActionButton/ToolbarPrimaryActionButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Button, useTheme } from '@mui/material';
import Tooltip from '../../atoms/Tooltip/Tooltip';
import { useTheme as useDesignTheme } from '../../../design-system/providers/ThemeProvider';
import {
  operationalElevation,
  operationalFontSizes,
  operationalRadii,
  operationalSizing,
  operationalSpacing
} from '../../../design-system/tokens';

const ToolbarPrimaryActionButton = ({
  tooltip,
  label,
  icon,
  onClick,
  className = '',
  sx,
  ...props
}) => {
  const theme = useTheme();
  const { primaryGradient } = useDesignTheme();

  return (
    <Tooltip title={tooltip}>
      <Button
        variant="contained"
        startIcon={icon}
        onClick={onClick}
        className={`toolbar-primary-action-button ${className}`}
        sx={{
          height: operationalSizing.compact,
          px: operationalSpacing.lg,
          py: operationalSpacing.xs,
          fontSize: operationalFontSizes.sm,
          borderRadius: `${operationalRadii.control}px`,
          background: primaryGradient || theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          '&:hover': {
            filter: 'brightness(0.9)',
            boxShadow: operationalElevation.surface
          },
          ...sx
        }}
        {...props}
      >
        <span translate="no">{label}</span>
      </Button>
    </Tooltip>
  );
};

ToolbarPrimaryActionButton.propTypes = {
  tooltip: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  sx: PropTypes.object
};

export default ToolbarPrimaryActionButton;
